import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropdownDefaultButtons = _resolveComponent("DropdownDefaultButtons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropdownDefaultButtons)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Single buttons"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex gap-2 flex-wrap" }, [
                _createElementVNode("div", { class: "dropdown d-inline-block" }, [
                  _createElementVNode("button", {
                    class: "btn btn-primary text-white py-2 px-3 dropdown-toggle",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, " Primary "),
                  _createElementVNode("ul", { class: "dropdown-menu bg-primary" }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Another action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Something else here")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "dropdown d-inline-block" }, [
                  _createElementVNode("button", {
                    class: "btn btn-secondary text-white py-2 px-3 dropdown-toggle",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, " Secondary "),
                  _createElementVNode("ul", { class: "dropdown-menu bg-secondary" }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Another action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Something else here")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "dropdown d-inline-block" }, [
                  _createElementVNode("button", {
                    class: "btn btn-success text-white py-2 px-3 dropdown-toggle",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, " Success "),
                  _createElementVNode("ul", { class: "dropdown-menu bg-success" }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Another action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Something else here")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "dropdown d-inline-block" }, [
                  _createElementVNode("button", {
                    class: "btn btn-info text-white py-2 px-3 dropdown-toggle",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, " Info "),
                  _createElementVNode("ul", { class: "dropdown-menu bg-info" }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Another action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Something else here")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "dropdown d-inline-block" }, [
                  _createElementVNode("button", {
                    class: "btn btn-warning text-white py-2 px-3 dropdown-toggle",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, " Warning "),
                  _createElementVNode("ul", { class: "dropdown-menu bg-warning" }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Another action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Something else here")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "dropdown d-inline-block" }, [
                  _createElementVNode("button", {
                    class: "btn btn-danger text-white py-2 px-3 dropdown-toggle",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, " Danger "),
                  _createElementVNode("ul", { class: "dropdown-menu bg-danger" }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Another action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Something else here")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "dropdown d-inline-block" }, [
                  _createElementVNode("button", {
                    class: "btn btn-dark text-white py-2 px-3 dropdown-toggle",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, " Dark "),
                  _createElementVNode("ul", { class: "dropdown-menu bg-dark" }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Another action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-white",
                        href: "#"
                      }, "Something else here")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "dropdown d-inline-block" }, [
                  _createElementVNode("button", {
                    class: "btn btn-light text-white py-2 px-3 dropdown-toggle",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, " Light "),
                  _createElementVNode("ul", { class: "dropdown-menu bg-light" }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-dark",
                        href: "#"
                      }, "Action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-dark",
                        href: "#"
                      }, "Another action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item text-dark",
                        href: "#"
                      }, "Something else here")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<div class=\"dropdown d-inline-block\">\n<button class=\"btn btn-primary text-white py-2 px-3 dropdown-toggle\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nPrimary\n</button>\n<ul class=\"dropdown-menu bg-primary\">\n<li><a class=\"dropdown-item text-white\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Something else here</a></li>\n</ul>\n</div>\n\n<div class=\"dropdown d-inline-block\">\n<button class=\"btn btn-secondary text-white py-2 px-3 dropdown-toggle\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nSecondary\n</button>\n<ul class=\"dropdown-menu bg-secondary\">\n<li><a class=\"dropdown-item text-white\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Something else here</a></li>\n</ul>\n</div>\n\n<div class=\"dropdown d-inline-block\">\n<button class=\"btn btn-success text-white py-2 px-3 dropdown-toggle\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nSuccess\n</button>\n<ul class=\"dropdown-menu bg-success\">\n<li><a class=\"dropdown-item text-white\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Something else here</a></li>\n</ul>\n</div>\n\n<div class=\"dropdown d-inline-block\">\n<button class=\"btn btn-info text-white py-2 px-3 dropdown-toggle\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nInfo\n</button>\n<ul class=\"dropdown-menu bg-info\">\n<li><a class=\"dropdown-item text-white\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Something else here</a></li>\n</ul>\n</div>\n\n<div class=\"dropdown d-inline-block\">\n<button class=\"btn btn-warning text-white py-2 px-3 dropdown-toggle\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nWarning\n</button>\n<ul class=\"dropdown-menu bg-warning\">\n<li><a class=\"dropdown-item text-white\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Something else here</a></li>\n</ul>\n</div>\n\n<div class=\"dropdown d-inline-block\">\n<button class=\"btn btn-danger text-white py-2 px-3 dropdown-toggle\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nDanger\n</button>\n<ul class=\"dropdown-menu bg-danger\">\n<li><a class=\"dropdown-item text-white\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Something else here</a></li>\n</ul>\n</div>\n\n<div class=\"dropdown d-inline-block\">\n<button class=\"btn btn-dark text-white py-2 px-3 dropdown-toggle\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nDark\n</button>\n<ul class=\"dropdown-menu bg-dark\">\n<li><a class=\"dropdown-item text-white\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item text-white\" href=\"#\">Something else here</a></li>\n</ul>\n</div>\n\n<div class=\"dropdown d-inline-block\">\n<button class=\"btn btn-light text-white py-2 px-3 dropdown-toggle\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nLight\n</button>\n<ul class=\"dropdown-menu bg-light\">\n<li><a class=\"dropdown-item text-dark\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item text-dark\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item text-dark\" href=\"#\">Something else here</a></li>\n</ul>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Split Button Dropdown"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex flex-wrap gap-2" }, [
                _createElementVNode("div", { class: "d-inline-block" }, [
                  _createElementVNode("div", { class: "btn-group" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary text-white py-2 px-3"
                    }, " Primary "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary text-white py-2 px-3 dropdown-toggle dropdown-toggle-split",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Primary")
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu bg-white" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Another action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Something else here")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("hr", { class: "dropdown-divider" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Separated link")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "d-inline-block" }, [
                  _createElementVNode("div", { class: "btn-group" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary text-white py-2 px-3"
                    }, " Secondary "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary text-white py-2 px-3 dropdown-toggle dropdown-toggle-split",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Primary")
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu bg-white" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Another action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Something else here")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("hr", { class: "dropdown-divider" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Separated link")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "d-inline-block" }, [
                  _createElementVNode("div", { class: "btn-group" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-success text-white py-2 px-3"
                    }, " Success "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-success text-white py-2 px-3 dropdown-toggle dropdown-toggle-split",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Success")
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu bg-white" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Another action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Something else here")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("hr", { class: "dropdown-divider" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Separated link")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "d-inline-block" }, [
                  _createElementVNode("div", { class: "btn-group" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-info text-white py-2 px-3"
                    }, " Info "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-info text-white py-2 px-3 dropdown-toggle dropdown-toggle-split",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Info")
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu bg-white" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Another action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Something else here")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("hr", { class: "dropdown-divider" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Separated link")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "d-inline-block" }, [
                  _createElementVNode("div", { class: "btn-group" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-warning text-white py-2 px-3"
                    }, " Warning "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-warning text-white py-2 px-3 dropdown-toggle dropdown-toggle-split",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Warning")
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu bg-white" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Another action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Something else here")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("hr", { class: "dropdown-divider" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Separated link")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "d-inline-block" }, [
                  _createElementVNode("div", { class: "btn-group" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger text-white py-2 px-3"
                    }, " Danger "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger text-white py-2 px-3 dropdown-toggle dropdown-toggle-split",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Danger")
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu bg-white" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Another action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Something else here")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("hr", { class: "dropdown-divider" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Separated link")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "d-inline-block" }, [
                  _createElementVNode("div", { class: "btn-group" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-dark text-white py-2 px-3"
                    }, " Dark "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-dark text-white py-2 px-3 dropdown-toggle dropdown-toggle-split",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Dark")
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu bg-white" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Another action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Something else here")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("hr", { class: "dropdown-divider" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Separated link")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "d-inline-block" }, [
                  _createElementVNode("div", { class: "btn-group" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light text-white py-2 px-3"
                    }, " Light "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light text-white py-2 px-3 dropdown-toggle dropdown-toggle-split",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Light")
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu bg-white" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Another action")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Something else here")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("hr", { class: "dropdown-divider" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#"
                        }, "Separated link")
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<div class=\"d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-primary text-white py-2 px-3\">Primary</button>\n<button type=\"button\" class=\"btn btn-primary text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Primary</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-secondary text-white py-2 px-3\">Secondary</button>\n<button type=\"button\" class=\"btn btn-secondary text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Primary</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-success text-white py-2 px-3\">Success</button>\n<button type=\"button\" class=\"btn btn-success text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Success</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-info text-white py-2 px-3\">Info</button>\n<button type=\"button\" class=\"btn btn-info text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Info</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-warning text-white py-2 px-3\">Warning</button>\n<button type=\"button\" class=\"btn btn-warning text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Warning</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-danger text-white py-2 px-3\">Danger</button>\n<button type=\"button\" class=\"btn btn-danger text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Danger</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-dark text-white py-2 px-3\">Dark</button>\n<button type=\"button\" class=\"btn btn-dark text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Dark</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n<div class=\"d-inline-block\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-light text-white py-2 px-3\">Light</button>\n<button type=\"button\" class=\"btn btn-light text-white py-2 px-3 dropdown-toggle dropdown-toggle-split\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n<span class=\"visually-hidden\">Light</span>\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n<li><hr class=\"dropdown-divider\"></li>\n<li><a class=\"dropdown-item\" href=\"#\">Separated link</a></li>\n</ul>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Buttons With Icon"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab4",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent4"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex gap-4" }, [
                _createElementVNode("div", { class: "dropdown" }, [
                  _createElementVNode("button", {
                    class: "btn btn-primary text-primary bg-transparent p-0 border-0 dropdown-toggle",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, " Dropdown button "),
                  _createElementVNode("ul", { class: "dropdown-menu bg-white" }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#"
                      }, "Action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#"
                      }, "Another action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#"
                      }, "Something else here")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "dropdown" }, [
                  _createElementVNode("a", {
                    class: "btn btn-primary text-primary bg-transparent p-0 border-0 dropdown-toggle",
                    href: "#",
                    role: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, " Dropdown link "),
                  _createElementVNode("ul", { class: "dropdown-menu bg-white" }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#"
                      }, "Action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#"
                      }, "Another action")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#"
                      }, "Something else here")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, "\n<div class=\"dropdown\">\n<button class=\"btn btn-primary text-primary bg-transparent p-0 border-0 dropdown-toggle\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nDropdown button\n</button>\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n</ul>\n</div>\n<div class=\"dropdown\">\n<a class=\"btn btn-primary text-primary bg-transparent p-0 border-0 dropdown-toggle\" href=\"#\" role=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\nDropdown link\n</a>\n\n<ul class=\"dropdown-menu bg-white\">\n<li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n<li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n</ul>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Rounded Buttons"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab5",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview5-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code5-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent5"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex align-items-start gap-3" }, [
                _createElementVNode("ul", {
                  class: "dropdown-menus bg-white mb-0 list-unstyled p-3 rounded-2 bg-for-dark-mode",
                  style: {"box-shadow":"0px 10px 35px 0px rgba(50, 110, 189, 0.2)"}
                }, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item fs-14 mb-2",
                      href: "#"
                    }, "Today")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item fs-14 mb-2",
                      href: "#"
                    }, "Last 7 Days")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item fs-14 mb-2",
                      href: "#"
                    }, "Last Month")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item fs-14 mb-2",
                      href: "#"
                    }, "Last 12 Months")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item fs-14 mb-0",
                      href: "#"
                    }, "All Time")
                  ])
                ]),
                _createElementVNode("ul", {
                  class: "dropdown-menus bg-white mb-0 list-unstyled p-3 rounded-2 bg-for-dark-mode",
                  style: {"box-shadow":"0px 10px 35px 0px rgba(50, 110, 189, 0.2)"}
                }, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item fs-14 mb-2",
                      href: "#"
                    }, [
                      _createElementVNode("i", { class: "ri-stackshare-line" }),
                      _createTextVNode(" Share")
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item fs-14 mb-2",
                      href: "#"
                    }, [
                      _createElementVNode("i", { class: "ri-edit-line" }),
                      _createTextVNode(" Last 7 Days")
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item fs-14 mb-0",
                      href: "#"
                    }, [
                      _createElementVNode("i", { class: "ri-delete-bin-7-line" }),
                      _createTextVNode(" Last Month")
                    ])
                  ])
                ]),
                _createElementVNode("ul", {
                  class: "dropdown-menus bg-white mb-0 list-unstyled p-3 rounded-2 bg-for-dark-mode",
                  style: {"box-shadow":"0px 10px 35px 0px rgba(50, 110, 189, 0.2)"}
                }, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item fs-14 mb-2",
                      href: "#"
                    }, [
                      _createElementVNode("i", { class: "ri-user-line" }),
                      _createTextVNode(" Profile")
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item fs-14 mb-2",
                      href: "#"
                    }, [
                      _createElementVNode("i", { class: "ri-settings-3-line" }),
                      _createTextVNode(" Settings")
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item fs-14 mb-0",
                      href: "#"
                    }, [
                      _createElementVNode("i", { class: "ri-logout-circle-line" }),
                      _createTextVNode(" Logout")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode5"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode5"
                }, "\n<ul class=\"dropdown-menus bg-white mb-0 list-unstyled p-3 rounded-2\" style=\"box-shadow: 0px 10px 35px 0px rgba(50, 110, 189, 0.20);\">\n<li><a class=\"dropdown-item fs-14 mb-2\" href=\"#\">Today</a></li>\n<li><a class=\"dropdown-item fs-14 mb-2\" href=\"#\">Last 7 Days</a></li>\n<li><a class=\"dropdown-item fs-14 mb-2\" href=\"#\">Last Month</a></li>\n<li><a class=\"dropdown-item fs-14 mb-2\" href=\"#\">Last 12 Months</a></li>\n<li><a class=\"dropdown-item fs-14 mb-0\" href=\"#\">All Time</a></li>\n</ul>\n\n<ul class=\"dropdown-menus bg-white mb-0 list-unstyled p-3 rounded-2\" style=\"box-shadow: 0px 10px 35px 0px rgba(50, 110, 189, 0.20);\">\n<li><a class=\"dropdown-item fs-14 mb-2\" href=\"#\"><i class=\"ri-stackshare-line\"></i> Share</a></li>\n<li><a class=\"dropdown-item fs-14 mb-2\" href=\"#\"><i class=\"ri-edit-line\"></i> Last 7 Days</a></li>\n<li><a class=\"dropdown-item fs-14 mb-0\" href=\"#\"><i class=\"ri-delete-bin-7-line\"></i> Last Month</a></li>\n</ul>\n\n<ul class=\"dropdown-menus bg-white mb-0 list-unstyled p-3 rounded-2\" style=\"box-shadow: 0px 10px 35px 0px rgba(50, 110, 189, 0.20);\">\n<li><a class=\"dropdown-item fs-14 mb-2\" href=\"#\"><i class=\"ri-user-line\"></i> Profile</a></li>\n<li><a class=\"dropdown-item fs-14 mb-2\" href=\"#\"><i class=\"ri-settings-3-line\"></i> Settings</a></li>\n<li><a class=\"dropdown-item fs-14 mb-0\" href=\"#\"><i class=\"ri-logout-circle-line\"></i> Logout</a></li>\n</ul>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1))
  ]))
}